import {adminHttpClient} from "../commons/adminHttpClient";

const deleteNewsAudit = (id : string) : Promise<any> => {
    return adminHttpClient.delete(`/NewsAudits/Delete`, {
        data:{id : id}
    })
}

export default deleteNewsAudit;